import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import { parse } from 'date-fns';
import { useEffect, useMemo } from 'react';
import { fetchContracts } from 'products/nomad_insurance/state/contract';
import { useLocation } from 'react-router';
import { PAYMENT_STATUS } from 'products/nomad_insurance/constants';

const useCurrentContract = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { selectedContract } = queryString.parse(location.search);
  const { activePaidContracts, contractsIncludingExpired, activeContract } = useSelector(
    (state) => state.nomadInsurance.contract
  );
  const { isAuthenticated } = useSelector((state) => state.app.user);

  useEffect(() => {
    if (!activePaidContracts && isAuthenticated) {
      dispatch(fetchContracts());
    }
  }, [activePaidContracts, dispatch, isAuthenticated]);

  const currentContract = useMemo(() => {
    if (
      contractsIncludingExpired &&
      contractsIncludingExpired.length > 1 &&
      selectedContract
    ) {
      return contractsIncludingExpired.find(
        (item) => item.insuranceContractID === Number(selectedContract)
      );
    }
    return activeContract;
  }, [activePaidContracts, selectedContract]);

  const swContracts = useMemo(() => {
    return contractsIncludingExpired?.filter(
      (item) => item.insuranceProvider === 'SAFETYWING'
    );
  }, [contractsIncludingExpired]);

  const tmContracts = useMemo(() => {
    return contractsIncludingExpired?.filter(
      (item) => item.insuranceProvider !== 'SAFETYWING'
    );
  }, [contractsIncludingExpired]);

  const isPendingPayment =
    currentContract?.paymentStatus === PAYMENT_STATUS.PENDING_PAYMENT;
  const isPaused = currentContract?.paymentStatus === PAYMENT_STATUS.PAUSED;
  const isDisabled = isPendingPayment || isPaused;
  const isRenewal = currentContract?.paymentStatus === PAYMENT_STATUS.RENEWAL;
  const isRecurring = currentContract?.type === 'RECURRING';
  const isFailed = currentContract?.paymentStatus === PAYMENT_STATUS.FAILED;
  const isFixed = currentContract?.type === 'FIXED';
  const hasBothWTAndSW = swContracts?.length > 0 && tmContracts?.length > 0;
  const hasPassedEndDate = currentContract?.endDate
    ? parse(currentContract.endDate, 'yyyy-MM-dd', new Date()) <
      parse(new Date().toISOString().split('T')[0], 'yyyy-MM-dd', new Date())
    : false;
  // TODO: Remove default deductible when backend is updated
  const deductible = currentContract?.deductible ?? 250;

  return {
    currentContract,
    isPendingPayment,
    isPaused,
    isDisabled,
    isRenewal,
    isRecurring,
    isFailed,
    isFixed,
    swContracts,
    hasBothWTAndSW,
    contractsIncludingExpired,
    tmContracts,
    hasPassedEndDate,
    deductible
  };
};

export default useCurrentContract;
